const TokenService = {
    setToken: (accessToken, refreshToken) => {
        localStorage.setItem("EFFaccess_token", accessToken);
        localStorage.setItem("EFFrefresh_token", refreshToken)
    },
    getAccessToken: () => localStorage.getItem("EFFaccess_token"),
    getRefreshToken: () => localStorage.getItem("EFFrefresh_token"),
    removeToken: () => {
        localStorage.removeItem("EFFaccess_token");
        localStorage.removeItem("EFFrefresh_token");
    }
};

export default TokenService
